<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Edit Benefits
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Individual deductible"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.individualDeductible"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Family deductible"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.familyDeductible"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Individual deductible remaining"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.individualDeductibleRemaining"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Family deductible remaining"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.familyDeductibleRemaining"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Individual OOP"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.individualMaxOop"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Family OOP"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.familyMaxOop"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Individual OOP remaining"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.individualMaxOopRemaining"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Family OOP remaining"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.familyMaxOopRemaining"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="Coinsurance"
                          label-class="text-right">
              <b-input-group append="%">
                <b-form-input v-model="verification.individualCoInsurance"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="verification.isAsc">
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="ASC copay"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input v-model="verification.ascCopayAmount"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label-cols="8"
                          label="ASC coinsurance"
                          label-class="text-right">
              <b-input-group append="%">
                <b-form-input v-model="verification.ascCoinsurance"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveBenefits()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import _ from 'lodash'

  export default {
    name: 'EditBenefitsModal',

    components: {},

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      estimate: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        isSaving: false,
        verification: {
          estimateId: 0,
          individualDeductible: 0,
          familyDeductible: 0,
          individualDeductibleRemaining: 0,
          familyDeductibleRemaining: 0,
          individualMaxOop: 0,
          familyMaxOop: 0,
          individualMaxOopRemaining: 0,
          familyMaxOopRemaining: 0,
          individualCoInsurance: 0,
          ascCoinsurance: null,
          ascCopayAmount: null,
          isAsc: false
        }
      }
    },

    watch: {
      estimate (newValue, oldValue) {
        this.clearData()
        this.loadBenefits()
      },

      visible (newValue) {
        if (newValue) {
          this.loadBenefits()
        } else {
          this.clearData()
        }
      }
    },

    computed: {},

    methods: {
      loadBenefits () {
        this.verification.estimateId = this.estimate.organizationPatientEstimateId

        if (this.estimate.isAsc) {
          this.verification.ascCoinsurance = this.estimate.ascCoinsurance * 100
          this.verification.ascCopayAmount = this.estimate.ascCopayAmount
          this.verification.isAsc = true
        }

        const verification = this.estimate.insuranceVerification
        if (!verification) return

        this.verification.individualDeductible = verification.individualDeductible
        this.verification.familyDeductible = verification.familyDeductible
        this.verification.individualDeductibleRemaining = verification.individualDeductibleRemaining
        this.verification.familyDeductibleRemaining = verification.familyDeductibleRemaining
        this.verification.individualMaxOop = verification.individualMaxOop
        this.verification.familyMaxOop = verification.familyMaxOop
        this.verification.individualMaxOopRemaining = verification.individualMaxOopRemaining
        this.verification.familyMaxOopRemaining = verification.familyMaxOopRemaining
        this.verification.individualCoInsurance = verification.individualCoInsurance * 100
      },

      saveBenefits () {
        const self = this
        if (this.isSaving) {
          return
        }

        const verification = _.assign({}, this.verification)
        if (verification.individualCoInsurance) {
          verification.individualCoInsurance = verification.individualCoInsurance / 100
        }
        if (verification.ascCoinsurance) {
          verification.ascCoinsurance = verification.ascCoinsurance / 100
        }

        api.post('/Dashboard/Estimate/UpdateBenefits', verification).then(response => {
          self.isSaving = false
          self.$emit('update:visible', false)
          self.$emit('updateBenefits', true)
        })
        this.isSaving = true
      },

      clearData () {
        this.verification = {}
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    },

    created () {
    }
  }
</script>

<style scoped>
</style>
